module.exports = __webpack_public_path__ + "static/media/office_chair.2759db14.svg";